// Generated by CoffeeScript 2.7.0
var AbortModal, newAbortModal;

import ModalMixin from 'trunks/vue/admin/mixins/modal.js';

AbortModal = Vue.extend({
  mixins: [ModalMixin],
  data: function() {
    return {
      value: ''
    };
  },
  template: `<div class="modal confirm"
     :class='statusClass'
     v-animationend.stop='animationEnd'>
  <div class="content" v-animationend.stop ref="content">
    <div class="confirm-header">
      <div class="confirm-icon">
        <i class="slp-warning-circle-o error-text"></i>
      </div>
      <div class="confirm-title">
        终止流程？
      </div>
    </div>
    <div class="confirm-body">
      <div class="mb-4">流程将被终止，此操作无法撤销</div>
      <div class="form-field">
        <div class="form-field-head">
          <div class="form-field-title text-left">终止原因</div>
        </div>
        <div class="form-field-input-container">
          <div class="form-field-input">
            <textarea v-model.trim="value" class="form-field-value" type="text" placeholder="请输入终止原因" rows="6"/>
          </div>
        </div>
      </div>
    </div>
    <div class="confirm-footer">
      <button class="btn btn-default outlined" @click='cancel'>取消</button>
      <button class="btn btn-danger" @click='ensure'>确认</button>
    </div>
  </div>
</div>`
});

newAbortModal = function(settings = {}) {
  return new AbortModal({
    el: settings.el || Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('confirm_container'),
    propsData: settings
  });
};

export {
  newAbortModal
};
